module.exports = __webpack_public_path__ + "static/media/beneifit2.f7fb51b0.png";